import { CircleX } from 'lucide-react';
import React from 'react';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@column/ui';

export const AuthorizationCell = ({ isAuthorized }: { isAuthorized?: boolean }) => {
  if (isAuthorized) {
    return null;
  }

  return (
    <div className="flex h-10 items-center justify-center">
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="flex text-orange-500 dark:text-orange-400">
              <CircleX className="size-4" />
              <span className="sr-only">Not sendable</span>
            </span>
          </TooltipTrigger>
          <TooltipContent side="right" className="max-w-xs">
            You do not have permission to send this transfer.
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};
